<template>
  <v-container v-if="pageDataReady.isReady">

    <v-breadcrumbs divider="/" class="ml-1 pb-0">
      <v-breadcrumbs-item
          v-for="breadcrumb in breadcrumbs"
          :key="breadcrumb.name"
          :disabled="typeof breadcrumb.link === 'undefined'"
          :to="typeof breadcrumb.link !== 'undefined' ? breadcrumb.link : ''"
      >
        {{ breadcrumb.name }}
      </v-breadcrumbs-item>
    </v-breadcrumbs>

    <v-form ref="form" validation @input="checkValidate" class="ml-3">
      <h1 class="my-3">Редактирование торговой точки</h1>

      <v-layout row>
        <v-flex xs12 lg8 md8>
          <v-text-field
              label="Фактический адрес"
              v-model="factAddress"
              :rules="textInputRules"
              validate-on-blur
              outline
          ></v-text-field>
        </v-flex>
      </v-layout>

      <v-layout row>
        <v-flex xs12 lg8 md8>
          <v-text-field
              label="Телефон"
              v-model="phone"
              :rules="textInputRules"
              mask="+7 (###) ###-##-##"
              validate-on-blur
              outline
          ></v-text-field>
        </v-flex>
      </v-layout>

      <v-layout row>
        <v-flex xs6 lg4 md4>
          <v-select
              :items="wayList"
              item-text="title"
              item-value="id"
              label="Маршрут"
              v-model="way.id"
              outline
              no-data-text="Нет данных"
          ></v-select>
        </v-flex>
      </v-layout>

      <p class="title">Расписание доставки</p>
      <v-layout row>
        <v-flex xs8 lg6 md6 class="elevation-1 mb-3 white">
          <v-layout row class="pt-4">
            <v-checkbox hide-details class="shrink ml-3 mr-2" v-model="schedule.monday.enabled" @input="!schedule.monday.enabled ? schedule.monday.value = null : false"></v-checkbox>
            <v-text-field
                label="Понедельник"
                class="mr-3"
                v-model="schedule.monday.value"
                :disabled="!schedule.monday.enabled"
                outline
            ></v-text-field>
          </v-layout>
          <v-layout row>
            <v-checkbox hide-details class="shrink ml-3 mr-2" v-model="schedule.tuesday.enabled" @input="!schedule.tuesday.enabled ? schedule.tuesday.value = null : false"></v-checkbox>
            <v-text-field
                label="Вторник"
                class="mr-3"
                v-model="schedule.tuesday.value"
                :disabled="!schedule.tuesday.enabled"
                outline
            ></v-text-field>
          </v-layout>
          <v-layout row>
            <v-checkbox hide-details class="shrink ml-3 mr-2" v-model="schedule.wednesday.enabled" @input="!schedule.wednesday.enabled ? schedule.wednesday.value = null : false"></v-checkbox>
            <v-text-field
                label="Среда"
                class="mr-3"
                v-model="schedule.wednesday.value"
                :disabled="!schedule.wednesday.enabled"
                outline
            ></v-text-field>
          </v-layout>
          <v-layout row>
            <v-checkbox hide-details class="shrink ml-3 mr-2" v-model="schedule.thursday.enabled" @input="!schedule.thursday.enabled ? schedule.thursday.value = null : false"></v-checkbox>
            <v-text-field
                label="Четверг"
                class="mr-3"
                v-model="schedule.thursday.value"
                :disabled="!schedule.thursday.enabled"
                outline
            ></v-text-field>
          </v-layout>
          <v-layout row>
            <v-checkbox hide-details class="shrink ml-3 mr-2" v-model="schedule.friday.enabled" @input="!schedule.friday.enabled ? schedule.friday.value = null : false"></v-checkbox>
            <v-text-field
                label="Пятница"
                class="mr-3"
                v-model="schedule.friday.value"
                :disabled="!schedule.friday.enabled"
                outline
            ></v-text-field>
          </v-layout>
          <v-layout row>
            <v-checkbox hide-details class="shrink ml-3 mr-2" v-model="schedule.saturday.enabled" @input="!schedule.saturday.enabled ? schedule.saturday.value = null : false"></v-checkbox>
            <v-text-field
                label="Суббота"
                class="mr-3"
                v-model="schedule.saturday.value"
                :disabled="!schedule.saturday.enabled"
                outline
            ></v-text-field>
          </v-layout>
          <v-layout row>
            <v-checkbox hide-details class="shrink ml-3 mr-2" v-model="schedule.sunday.enabled" @input="!schedule.sunday.enabled ? schedule.sunday.value = null : false"></v-checkbox>
            <v-text-field
                label="Воскресение"
                class="mr-3"
                v-model="schedule.sunday.value"
                :disabled="!schedule.sunday.enabled"
                outline
            ></v-text-field>
          </v-layout>
        </v-flex>
      </v-layout>

      <v-layout row class="mb-3">
        <v-flex xs12 lg8 md8>
          <p class="title">Точка на карте</p>
          <yandex-map
              :coords="coordinate !== null ? coordinate : [55, 35]"
              zoom="3"
              style="width: 100%; height: 400px;"
              @map-was-initialized="initMap"
          >
            <ymap-marker
                v-if="coordinate !== null"
                :marker-id="1"
                marker-type="placemark"
                :coords="coordinate"
            ></ymap-marker>
          </yandex-map>
        </v-flex>
      </v-layout>

      <v-layout row class="pa-0 ma-0">
        <v-flex xs12 lg6 md6 v-if="pointStatus !== null ? pointStatus.id === 1 : false">
          <v-btn
              :loading="loading"
              :disabled="!valid || loading"
              color="primary"
              @click.native="loader = 'loading'"
              class="ma-0"
              @click="onClickEditPoint"
          >
            Продолжить
          </v-btn>
          <v-btn
              color="error"
              class="ma-0"
              @click="cancelDialog = true"
          >
            Отклонить
          </v-btn>
        </v-flex>
        <v-flex xs12 lg6 md6 v-if="pointStatus !== null ? pointStatus.id === 2 || pointStatus.id === 3 : false">
          <v-btn
              :loading="loading"
              :disabled="!valid || loading"
              color="primary"
              @click.native="loader = 'loading'"
              class="ma-0"
              @click="onClickEditPoint"
          >
            Изменить
          </v-btn>
        </v-flex>
      </v-layout>

      <v-dialog
          v-model="cancelDialog"
          max-width="300"
      >
        <v-card>
          <v-card-title class="headline">Отклонить заявку?</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
                color="error"
                @click="cancelPointConfirm()"
            >
              Да
            </v-btn>

            <v-btn
                @click="cancelPointOnCancel()"
            >
              Нет
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-form>
  </v-container>
</template>

<script>
  export default {
    data: () => ({
      breadcrumbs: [
        {name: 'Главная', link: '/'},
        {name: 'Заявки', link: '/points/request/logistics/list'},
        {name: 'Редактирование торговой точки'}
      ],
      pageDataReady: {
        isReady: false,
        point: false,
        wayList: false
      },
      id: null,
      factAddress: null,
      phone: null,
      pointStatus: null,
      coordinate: null,
      schedule: {
        monday: {enabled: false, value: null},
        tuesday: {enabled: false, value: null},
        wednesday: {enabled: false, value: null},
        thursday: {enabled: false, value: null},
        friday: {enabled: false, value: null},
        saturday: {enabled: false, value: null},
        sunday: {enabled: false, value: null}
      },
      way: {id: null, title: null},
      map: null,

      cancelDialog: false,
      cancelPointId: null,

      valid: false,
      textInputRules: [
        v => !!v || 'Обязательное поле'
      ]
    }),
    methods: {
      pageDataStatus () {
        if (!this.pageDataReady.point) {
          return false
        }
        if (!this.pageDataReady.wayList) {
          return false
        }
        this.pageDataReady.isReady = true
        this.$store.commit('setPageLoading', false)
      },
      initMap (instance) {
        this.map = instance
        this.map.behaviors.disable('scrollZoom')
        let _this = this
        this.mapZoomUpdate()
        this.map.events.add('click', function (e) {
          _this.coordinate = [e.get('coords')[0].toPrecision(6), e.get('coords')[1].toPrecision(6)]
        })
      },
      mapZoomUpdate () {
        if (this.map !== null && this.map.geoObjects.getBounds() !== null) {
          this.map.setBounds(this.map.geoObjects.getBounds())
          if (this.map.getZoom() > 18) {
            this.map.setZoom(18)
          }
        }
      },
      checkValidate () {
        this.valid = true
        return this.valid
      },
      cancelPointOnCancel () {
        this.cancelDialog = false
        this.cancelPointId = null
      },
      async cancelPointConfirm () {
        await this.$store.dispatch('logisticsDeclinePoint', {id: this.id})
          .then((data) => {
            this.$router.push('/points/request/logistics/list')
          })
          .catch((e) => {
            console.log(e)
          })
      },
      async onClickEditPoint () {
        let data = {
          id: this.id,
          fact_address: this.factAddress,
          phone: this.phone,
          way_id: this.way.id
        }

        data.schedule = {
          monday: this.schedule.monday.value,
          tuesday: this.schedule.tuesday.value,
          wednesday: this.schedule.wednesday.value,
          thursday: this.schedule.thursday.value,
          friday: this.schedule.friday.value,
          saturday: this.schedule.saturday.value,
          sunday: this.schedule.sunday.value
        }

        if (this.coordinate !== null) {
          data.coordinate = {
            lat: this.coordinate[0],
            lng: this.coordinate[1]
          }
        }

        await this.$store.dispatch('logisticsUpdatePoint', data)
          .then((data) => {
            if (typeof data.point !== 'undefined') {
              this.$router.push('/points/logistics/single/' + this.id)
            }
          })
          .catch((e) => {
            console.log(e)
          })
      },
      onCreated () {
        this.$store.commit('setPageLoading', true)
        this.map = null
        this.id = null
        this.factAddress = null
        this.phone = '+7'
        this.coordinate = null
        this.pointStatus = null
        this.way = {id: null, title: null}
        this.schedule = {
          monday: {enabled: false, value: null},
          tuesday: {enabled: false, value: null},
          wednesday: {enabled: false, value: null},
          thursday: {enabled: false, value: null},
          friday: {enabled: false, value: null},
          saturday: {enabled: false, value: null},
          sunday: {enabled: false, value: null}
        }

        if (~this.$router.currentRoute.path.indexOf('/points/logistics/edit/')) {
          this.id = parseInt(this.$route.params.id)
        }

        this.$store.commit('setPageTitle', 'Редактирование торговой точки')

        this.$store.dispatch('getPointSingle', {id: this.id})
          .then(() => {
            this.pageDataReady.point = true
            this.pageDataStatus()
          })
        this.$store.dispatch('getWayList')
          .then(() => {
            this.pageDataReady.wayList = true
            this.pageDataStatus()
          })
      }
    },
    computed: {
      loading () {
        return this.$store.getters.loading
      },
      pointSingle () {
        return this.$store.getters.pointSingle
      },
      wayList () {
        return this.$store.getters.wayList
      }
    },
    created () {
      this.onCreated()
    },
    watch: {
      '$route' (to, from) {
        this.onCreated()
      },
      pointSingle (val) {
        if (this.pointSingle !== null) {
          this.factAddress = this.pointSingle.fact_address !== null ? this.pointSingle.fact_address : null
          this.phone = this.pointSingle.phone !== null ? this.pointSingle.phone : null
          this.pointStatus = this.pointSingle.point_status !== null ? this.pointSingle.point_status : null
          if (this.pointSingle.coordinate !== null) {
            this.coordinate = [this.pointSingle.coordinate.lat, this.pointSingle.coordinate.lng]
          }
          this.way = this.pointSingle.way !== null ? this.pointSingle.way : {id: null, title: null}
          if (typeof this.pointSingle.cargo_schedule !== 'undefined') {
            if (this.pointSingle.cargo_schedule !== null) {
              this.schedule = {
                monday: this.pointSingle.cargo_schedule.monday !== '' ? {enabled: true, value: this.pointSingle.cargo_schedule.monday} : {enabled: false, value: null},
                tuesday: this.pointSingle.cargo_schedule.tuesday !== '' ? {enabled: true, value: this.pointSingle.cargo_schedule.tuesday} : {enabled: false, value: null},
                wednesday: this.pointSingle.cargo_schedule.wednesday !== '' ? {enabled: true, value: this.pointSingle.cargo_schedule.wednesday} : {enabled: false, value: null},
                thursday: this.pointSingle.cargo_schedule.thursday !== '' ? {enabled: true, value: this.pointSingle.cargo_schedule.thursday} : {enabled: false, value: null},
                friday: this.pointSingle.cargo_schedule.friday !== '' ? {enabled: true, value: this.pointSingle.cargo_schedule.friday} : {enabled: false, value: null},
                saturday: this.pointSingle.cargo_schedule.saturday !== '' ? {enabled: true, value: this.pointSingle.cargo_schedule.saturday} : {enabled: false, value: null},
                sunday: this.pointSingle.cargo_schedule.sunday !== '' ? {enabled: true, value: this.pointSingle.cargo_schedule.sunday} : {enabled: false, value: null}
              }
            } else {
              this.schedule = {
                monday: {enabled: false, value: null},
                tuesday: {enabled: false, value: null},
                wednesday: {enabled: false, value: null},
                thursday: {enabled: false, value: null},
                friday: {enabled: false, value: null},
                saturday: {enabled: false, value: null},
                sunday: {enabled: false, value: null}
              }
            }
          }
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Points/PointLogisticsEdit.vue